import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../../../hooks';

const ItemTitleValue = ({ labelText }) => {
  const {
    //BidStore: { auction },
  } = useStores();

  const label = labelText ? `${labelText} ` : 'Item Title';
  //const lotNumber = auction.lotNumber;

  return (
    <h1 data-testid="itemtitle" >
      {label}
      {/* {lotNumber} */}
    </h1>
  );
};

export default observer(ItemTitleValue);
